import React, {
  ChangeEvent,
  Fragment,
  ReactNode
  // SetStateAction,
  // Dispatch
} from 'react'
import { GridElementFillRate } from '../GridElementFillRate/GridElementFillRate'
// import { Pagination } from '../../UI/Pagination/Pagination'
// import { Grid, Button } from '@mui/material'

import { NoRows } from '../../ElementList/NoRows'
import { SortField } from '../../../interfaces/DataGrid/DataGridSettings'
import { DataGrid } from '../../DataGrid/DataGrid'
import { dataGridSettings } from '../fillRateConfig'
import { FillRateData } from '../../../interfaces/DashBoard/FillRate'

interface FillRateElementListProps {
  plannerList: FillRateData[]
  page: number
  totalPages: number
  pageSize: number
  handlePagination: (updatePage: number) => void
  handlePageSize: (
    event: ChangeEvent<{ name?: string | undefined; value: unknown }>,
    child: ReactNode
  ) => void
  sorters: SortField[]
  handleOnSortChanged: (sorters: SortField[]) => void
}

export const FillRateElementList: React.FC<FillRateElementListProps> = ({
  plannerList,
  // page,
  // totalPages,
  // pageSize,
  // handlePagination,
  // handlePageSize,
  handleOnSortChanged,
  sorters
}) => {
  return (
    <Fragment>
      <DataGrid
        items={plannerList}
        settings={dataGridSettings}
        sorters={sorters}
        onSortChanged={handleOnSortChanged}
        displayHeader={false}
      >
        {(order) => (
          <GridElementFillRate
            element={order}
            dataGridSettings={dataGridSettings}
          />
        )}
      </DataGrid>

      {plannerList.length <= 0 && <NoRows />}
      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 10 }}>
        <Select
          native
          value={pageSize}
          onChange={handlePageSize}
          style={{ alignSelf: 'flex-end' }}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
        </Select>
      </div>
      <Pagination
        page={page}
        totalPages={totalPages}
        handlePagination={handlePagination}
      /> */}
    </Fragment>
  )
}
